import { copy } from "shared/assets";
import { IAutocomplete, IFieldType, IFormFields } from "shared/types";

const { userAddress, errors } = copy;

export const fields: IFormFields = [
  {
    name: "title",
    label: userAddress.fields.title,
    type: IFieldType.text,
    style: {
      gridColumn: "span 2",
      mobile: { gridColumn: "span 1" },
    },
  },
  {
    name: "address",
    hideContainer: true,
    style: {
      gridTemplateColumns: "1fr 1fr",
      mobile: { gridTemplateColumns: "1fr" },
    },
    fields: [
      {
        name: "addressLine1",
        label: userAddress.fields.addressLine1.title,
        type: IFieldType.text,
        autocomplete: IAutocomplete.addressLine1,
        note: userAddress.fields.addressLine1.note,
        validation: {
          required: errors.required,
        },
      },
      {
        name: "addressLine2",
        label: userAddress.fields.addressLine2.title,
        autocomplete: IAutocomplete.addressLine2,
        type: IFieldType.text,
        note: userAddress.fields.addressLine2.note,
      },
      {
        name: "city",
        label: userAddress.fields.city,
        type: IFieldType.text,
        validation: {
          required: errors.required,
        },
      },
      {
        name: "zip",
        label: userAddress.fields.zip,
        type: IFieldType.text,
        autocomplete: IAutocomplete.postalCode,
        validation: {
          required: errors.required,
        },
      },
      {
        name: "state",
        label: userAddress.fields.state,
        type: IFieldType.text,
      },
      {
        name: "country",
        label: userAddress.fields.country,
        type: IFieldType.country,
        autocomplete: IAutocomplete.country,
        validation: {
          required: errors.required,
        },
      },
    ],
  },
];
